<template>
  <el-dialog
    v-loading="isLoading"
    :visible="visible"
    fullscreen
    append-to-body
    class="img-orientation"
    @close="$emit('close')"
  >
    <el-row v-if="current" ref="lazy" class="img-orient-lazy">
      <el-col
        v-for="file in current.files"
        :key="file.id"
        :span="12"
        class="img-orient-col"
      >
        <img-actions
          :file="file"
          :container="$refs.lazy"
          :type="type"
          :show="true"
        />
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button type="info" plain @click="$emit('close')">
        Закрыть без сохранения
      </el-button>
      <el-button type="success" @click="handleSave">
        Сохранить ТТН и перейти к новому файлу
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ImgActions from '@/views/UnknownFiles/components/ImgActions'

export default {
  name: 'ImgOrientationModal',
  components: { ImgActions },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('hardware', ['current', 'getLoading']),
    isLoading() {
      return this.getLoading()
    },
  },
  methods: {
    handleSave() {
      if (this.current?.files.find(file => !file.variant)) {
        return this.$message.warning('Выберите сторону на всех изображениях')
      }
      this.$emit('save')
    },
  },
}
</script>

<style lang="sass">
.img-orientation
  .el-dialog__header
    padding: 25px 0
  .el-dialog__body
    padding: 0 10px
    .img-orient-lazy
      height: calc(100vh - 131px)
      overflow: scroll
  .el-dialog__footer
    padding: 20px
  .img-orient-col
    padding: 0 10px
</style>
